import { useUnit } from 'effector-react';
import { $locale } from 'src/models/locale';
import { ru } from './ru';
import { en } from './en';

export const dictionaries = { ru, en };

export const getT = (locale) => dictionaries[locale] || dictionaries.ru;

export const useT = () => {
  const locale = useUnit($locale);

  return getT(locale);
};
